var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4863 4.34766C35.3138 4.34766 39.708 9.10241 39.708 15.4077V27.4267C39.708 30.6537 38.567 33.5692 36.4933 35.6377C34.633 37.4909 32.2198 38.4727 29.5143 38.4727H12.2715C9.57126 38.4727 7.15976 37.4927 5.29776 35.6377C3.22401 33.5692 2.08301 30.6537 2.08301 27.4267V15.4077C2.08301 9.10241 6.47726 4.34766 12.3048 4.34766H29.4863ZM29.4863 6.97266H12.3048C7.90351 6.97266 4.70801 10.5199 4.70801 15.4077V27.4267C4.70801 29.9519 5.57601 32.2077 7.15101 33.7774C8.50901 35.1337 10.2818 35.8477 12.2768 35.8477H29.4863C29.4898 35.8442 29.5038 35.8477 29.5143 35.8477C31.511 35.8477 33.282 35.1337 34.64 33.7774C36.2168 32.2077 37.083 29.9519 37.083 27.4267V15.4077C37.083 10.5199 33.8875 6.97266 29.4863 6.97266ZM32.2443 15.0731C32.701 15.6348 32.6153 16.4608 32.0535 16.9193L24.2765 23.2403C23.293 24.0208 22.117 24.4111 20.9428 24.4111C19.772 24.4111 18.6048 24.0243 17.6283 23.2508L9.77951 16.9228C9.21426 16.4678 9.12676 15.6401 9.58001 15.0766C10.0368 14.5148 10.8628 14.4256 11.4263 14.8788L19.268 21.1998C20.2533 21.9803 21.641 21.9803 22.6333 21.1928L30.3963 14.8823C30.9598 14.4221 31.7858 14.5096 32.2443 15.0731Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.77ea09c2099d600c28cea63cfbe15237.svg";
export { ForwardRef as ReactComponent };